import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HomeIcon from '@mui/icons-material/Home';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { generateDefaultScreenRoute } from '../utils/route';

interface Props {
  page: number;
  totalPage: number;
  onClickPrev?: () => void;
  onClickNext?: () => void;
}

export default function BottomNav({
  page,
  totalPage,
  onClickPrev,
  onClickNext,
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navClass = clsx(
    'rounded-full border border-white flex justify-center items-center cursor-pointer hover:bg-white hover:text-darkBlue'
  );

  const backToMainPage = () => {
    const defaultRoute = generateDefaultScreenRoute(
      parseInt(process.env.REACT_APP_DEFAULT_SCREEN, 10)
    );
    navigate(defaultRoute);
  };

  return (
    <div className="fixed left-1/2 right-1/2 -translate-x-1/2 -translate-y-1/2 w-[355px] bottom-20 text-white z-[2]">
      <div className="flex space-x-16">
        <div
          className={clsx('w-46 h-46', navClass, {
            invisible: page === 0,
          })}
          onClick={onClickPrev}
        >
          <ArrowBackIcon />
        </div>
        <div
          className={clsx('px-36 py-8 space-x-10', navClass)}
          onClick={backToMainPage}
        >
          <HomeIcon />
          <div className="font-semiBold">{t('mainPage')}</div>
        </div>
        <div
          className={clsx('w-46 h-46', navClass, {
            invisible: page === totalPage - 1,
          })}
          onClick={onClickNext}
        >
          <ArrowForwardIcon />
        </div>
      </div>
    </div>
  );
}
